import React, { useState } from 'react';
import { MBHover } from '@shared/components/hover';
import { MBChatAttachment } from '@shared/scenes/chat/thread/containers/attachmentWithUploadProgress';
import { grid } from '@shared/styles';

import { Styles } from '../styles';
import { MessageHoverContent } from './MessageHoverContent';

interface MBMessageBubbleAttachmentProps {
  message: MBAPI.ChatMessage;
  align: 'left' | 'right';
  attachment: MBAPI.ChatAttachment;
  channelSlug: string;
  isSent: boolean;
  onLongPress?: () => void;
  onClick?: (attachment: MBAPI.ChatAttachment) => void;
  isFirstMessageInGroup: boolean;
}

export function MBMessageBubbleAttachment({
  attachment,
  message,
  channelSlug,
  align,
  isSent,
  onLongPress,
  onClick,
  isFirstMessageInGroup,
}: MBMessageBubbleAttachmentProps) {
  const [isHovering, setIsHovering] = useState(false);
  const [dims, setDims] = useState({ width: 0, height: 0 });
  const showHoverContentWhenRight = isHovering;
  const showHoverContentWhenLeft = isHovering || !message.meta.reactions.length;

  return (
    <MBHover
      style={[
        align === 'left' && Styles.rowAlignLeft,
        align === 'right' && Styles.rowAlignRight,
        !isFirstMessageInGroup && { paddingTop: grid(1) },
      ]}
      onHoverStart={() => setIsHovering(true)}
      onHoverEnd={() => setIsHovering(false)}
      onSize={newDims => setDims(newDims)}
    >
      <>
        <MBChatAttachment
          attachment={attachment}
          style={Styles.bubbleMaxWidth}
          isSending={!isSent}
          onLongPress={onLongPress}
          onClick={onClick}
          containerWidth={dims.width}
          containerHeight={dims.height}
        />
        <MessageHoverContent
          showContent={align === 'right' ? showHoverContentWhenRight : showHoverContentWhenLeft}
          align={align}
          message={message}
          channelSlug={channelSlug}
          includeEdit={false}
        />
      </>
    </MBHover>
  );
}
